import React from "react";
import { Link, useNavigate } from "react-router-dom";
// import Carousel from "../../components/Carousel/Carousel";
import countryData from "../../data/countries.json";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Shipment from "../../components/Shipment/Shipment";
import ChatWithUs from "../../components/ChatWithUs/ChatWithUs";
import ShipImage from "../../assets/largeShipContainer.jpg"; // Ship background image
import FoodDisplayImage from "../../assets/Food-display-2.png";
import "./Home.css"; // Contains the updated styles

const Home = () => {
  const navigate = useNavigate();
  const china = countryData.find((c) => c.country === "China") || {
    categories: [],
  };

  const openCategory = (category) => {
    navigate("/products", {
      state: { country: "China", category: category.name },
    });
  };

  // Exclude Toys and Sport Items; show Textile, Baby Products, Garments, Furniture, Homeware
  const excludedCategories = new Set(["Toys", "Sport Items"]);
  const previewCategories = (china.categories || [])
    .filter((cat) => !excludedCategories.has(cat.name))
    .slice(0, 5);

  // use the 8th category's image as the View More tile background
  const viewMoreImage = (china.categories || [])[7]?.Image || "";

  // gridCells: 5 categories + null for View More (Food & Beverages fills the other 2 slots)
  const gridCells = [...previewCategories, null];

  return (
    <>
      <Navbar />
      {/* Home page wrapper that scopes Playfair Display to Home only */}
      <div className="home-page">
        {/* China categories preview on Home */}
        <section className="china-preview-section">
          <div
            className="china-preview-grid"
            role="list"
            aria-label="Popular China categories"
          >
            {/* Food & Beverages — spans 2 columns, always first */}
            <button
              className="china-preview-cell category-card food-bev-cell"
              onClick={() => navigate("/foodandbeverages")}
              style={{ backgroundImage: `url(${FoodDisplayImage})` }}
              aria-label="Open Food & Beverages products"
            >
              <span className="category-overlay" aria-hidden />
              <div className="category-title">
                <span>Food &amp; Beverages</span>
              </div>
            </button>

            {gridCells.map((cat, idx) => {
              // last cell (null) => View More button
              if (!cat) {
                return (
                  <div
                    key={`viewmore-${idx}`}
                    className="china-preview-cell view-more-cell"
                    style={{ backgroundImage: `url(${viewMoreImage})`, backgroundSize: "cover", backgroundPosition: "center" }}
                  >
                    <span className="category-overlay" aria-hidden />
                    <Link
                      to="/China"
                      className="view-more-button"
                      aria-label="View more products from China"
                    >
                      View More
                    </Link>
                  </div>
                );
              }

              return (
                <button
                  key={cat.name + "-" + idx}
                  className="china-preview-cell category-card"
                  onClick={() => openCategory(cat)}
                  style={{ backgroundImage: `url(${cat.Image})` }}
                  aria-label={`Open ${cat.name} products`}
                >
                  <span className="category-overlay" aria-hidden />
                  <div className="category-title">
                    <span>{cat.name}</span>
                  </div>
                </button>
              );
            })}
          </div>
        </section>
        
        
        <div
          className="ship-background"
          style={{ backgroundImage: `url(${ShipImage})` }}
        >
          <div className="ship-overlay">
            {/* First major div - Text content */}
            <div className="ship-left">
              <h2>Your one-stop export partner</h2>
              <p>
                From Product development to Sourcing
                <br />
                to Quality Control to Packaging and Shipping.
              </p>
            </div>

            {/* Second major div - Spacer */}
            <div className="ship-middle"></div>

            {/* Third major div - Feature boxes */}
            <div className="ship-right">
              <div className="feature-box">
                <div className="red-line"></div>
                <h4>
                  30+ years of
                  <br />
                  experience
                </h4>
                <p>
                  We breathe exports and
                  <br />
                  thrive for expansion.
                </p>
              </div>
              <div className="feature-box">
                <div className="red-line"></div>
                <h4>
                  Creative
                  <br />
                  Mindset
                </h4>
                <p>
                  We consider our clients as our partners
                  <br />
                  and bring out the best results for mutual benefits.
                </p>
              </div>
              <div className="feature-box">
                <div className="red-line"></div>
                <h4>
                  Quality &<br />
                  Trust Assured
                </h4>
                <p>
                  From the first step to the end,
                  <br />
                  we quality check your shipment for
                  <br />
                  accurate products with no exceptions.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Ship Background Section */}
        <Shipment />
        <Footer />
        <ChatWithUs />
      </div>
    </>
  );
};

export default Home;
